import { api } from '../../../../app/auth/apiSlice';

interface UserDataProps {
  hobbies?: string;
  phone2?: string;
  awards?: any;
  about?: string;
  image?: string;
  phone?: string;
  extension?: string;
  username?: string | null;
  email?: string;
  status?: string;
  project_name?: string;
  designation_name?: string;
  gender?: string;
  joining_date?: string;
  full_name?: string;
  id?: string;
  staff_pin?: string;
}

interface GetUserByPinParam {
  pin: any;
}

const ProfileSearchApi = api
  .enhanceEndpoints({
    addTagTypes: ['EmployeeSearch', 'EmployeeByPinSearch'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // menus
      getUserByParams: builder.query({
        query: ({ params }) => {
          return `/v1/main/staffs/?search=${params}`;
        },
        providesTags: ['EmployeeSearch'],
      }),
      getUserByPin: builder.query<UserDataProps, GetUserByPinParam>({
        query: ({ pin }) => {
          return `/v1/main/staffs/${pin}`;
        },
        providesTags: ['EmployeeByPinSearch'],
        keepUnusedDataFor: 1,
      }),
    }),
  });

export const { useGetUserByParamsQuery, useGetUserByPinQuery } =
  ProfileSearchApi;
